import { FC, PropsWithChildren, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import * as Sentry from '@sentry/browser'

import { trans } from '@/helpers/trans'
import { setToast } from '@/redux/toasts/toastsReducer'
import { ToastType } from '@/types'

import { version } from '../../../package.json'
import { isVersionGreaterThan } from './helpers/isVersionGreaterThan'

const COOLDOWN_TIME = 120000

export const ConnectedCacheBuster: FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation()
    const dispatch = useDispatch()
    const [cooldownIsActive, setCooldownIsActive] = useState(false)

    const resetCooldown = () => {
        setCooldownIsActive(false)
    }

    async function checkForUpdate() {
        if (cooldownIsActive) {
            return
        }

        setTimeout(resetCooldown, COOLDOWN_TIME)

        fetch(`/meta.json?${new Date().getTime()}`,
            {
                cache: 'no-cache',
            })
            .then((response) => response.json())
            .then((meta) => {
                const latestVersion = meta.version
                const currentVersion = version

                if (isVersionGreaterThan(latestVersion, currentVersion)) {
                    dispatch(setToast({
                        text: trans('pages.errors.versionUpdate', { version: latestVersion }),
                        type: ToastType.updateApp,
                    }))
                }
            })
            .catch((e) => {
                Sentry.captureException(e)
            })

        setCooldownIsActive(true)
    }

    useEffect(() => {
        checkForUpdate()
    }, [location])

    return (
        <>
            {children}
        </>
    )
}
